import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from "@angular/core";

import { ColorService } from "maps-angular-components";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { ToastService } from "maps-angular-components";
import { filter } from "rxjs/operators";
import { AuthService } from "./guards/auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit{
  title = "front-end";
  theme = this.getTheme();
  @Input("headerFooter") headerFooter: boolean;
  @Input() openMenuOne;

  showMenu = true;
  version: string;

  constructor(
    private router: Router,
    private ref: ChangeDetectorRef,
    public colorService: ColorService,
    private authService: AuthService,
    private toastService: ToastService,
    private snackBar: MatSnackBar
  ) {
    // this.authService.showMenuEmitter.subscribe(
    //   (show) => (this.showMenu = show)
    // );
    // console.log(window.location.hash);

    router.events.subscribe((val) => this.hideMenu());

    this.toastService.toaster$
      .pipe(
        filter(
          (toast) =>
            toast.message !== null &&
            toast.message !== undefined &&
            typeof toast.message === "string"
        )
      )
      .subscribe((toast) => {
        this.snackBar.open(toast.message, toast.action, toast.config);
      });
  }

  ngOnInit() {
    //this.authService.start();
  }

  hideMenu() {
    if (window.location.hash === "#/login") {
      this.headerFooter = false;
    } else {
      this.headerFooter = true;
      this.ref.detectChanges();
    }
    this.ref.detectChanges();
  }

  showEvent(event) {
    this.openMenuOne = event;
  }

  isAutenticado() {
    return this.authService.isAutenticado()
  }

  getTheme() {
    if (localStorage.getItem("colorSelected") === null) {
      localStorage.setItem("colorSelected", "positive");
    }
    return localStorage.getItem("colorSelected");
  }
}
